import React, { Component } from "react";
import PropTypes from "prop-types";
import seniorPlaymat from "../../assets/images/WRO2021-Senior.png";

import { withStyles } from "@mui/styles";
import styles from "./styles";
import { randomize } from "../../assets/scripts/logic.js";

class Home extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth,
      time: {
        hours: 0,
        minutes: "00",
        seconds: "00",
        milliseconds: "00",
      },
      duration1: 4 * 1000, // 3 seconds
      duration2: 2 * 60 * 1000 - 1000, // 2 Minutes
      timer: null,
      startReset: "Start Timer",
      countDown: false
    };
    this.startTimer = this.start.bind(this);
    this.resetTimer = this.reset.bind(this);
  }

  msToTime(duration2) {
    let milliseconds = parseInt((duration2 % 1000) / 10);
    let seconds = Math.floor((duration2 / 1000) % 60);
    let minutes = Math.floor((duration2 / (1000 * 60)) % 60);
    let hours = Math.floor((duration2 / (1000 * 60 * 60)) % 24);

    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');
    milliseconds = milliseconds.toString().padStart(2, '0');

    return {
      hours,
      minutes,
      seconds,
      milliseconds
    };
  }

  start() {
    this.setState(() => ({
      startReset: "Reset",
      countDown: true
    }));
    if (!this.state.timer) {
      this.state.startTime = Date.now();
      this.timer = window.setInterval(() => this.run1(), 10);
      // this.timer = window.setInterval(() => this.run2(), 10);
    }
  }

  reset() {
    this.setState(() => ({
      startReset: "Start Timer",
      time: {
        hours: 0,
        minutes: "00",
        seconds: "00",
        milliseconds: "00",
      }
    }));
    window.clearInterval(this.timer);
  }

  stopTimer = () => {
    window.clearInterval(this.timer);
    this.setState(() => ({
      startReset: "Reset",
    }));
  }

  run1() {
    const diff = Date.now() - this.state.startTime;

    // If you want to count up
    this.setState(() => ({
      time: this.msToTime(diff)
    }));

    // count down
    let remaining = this.state.duration1 - diff;
    if (remaining < 1000) {
      remaining = 1000;
    }
    this.setState(() => ({
      time: this.msToTime(remaining)
    }));
    if (remaining === 1000) {
      window.clearTimeout(this.timer);
      this.timer = null;
      this.timer = window.setInterval(() => this.run2(), 10);
      this.setState(() => ({
        countDown: false
      }));
    }
  }

  run2() {
    const diff = Date.now() - this.state.startTime;

    // If you want to count up
    // this.setState(() => ({
    //  time: this.msToTime(diff)
    // }));

    // count down
    let remaining = this.state.duration2 + this.state.duration1 - diff;
    if (remaining < 0) {
      remaining = 0;
    }
    this.setState(() => ({
      time: this.msToTime(remaining),
    }));
    if (remaining === 0) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth });
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }
  setRandomize = async (data) => {
    console.log(data);
    let surplusWater = document.getElementsByClassName("surplusWater");
    let surplusSolar = document.getElementsByClassName("surplusSolar");
    let surplusWind = document.getElementsByClassName("surplusWind");

    for (let i = 0; i < surplusWater.length; i++) {
      surplusWater[i].style.backgroundColor = (data.surplusArea === 1) ? 'transparent' : 'black'
    }
    for (let i = 0; i < surplusSolar.length; i++) {
      surplusSolar[i].style.backgroundColor = (data.surplusArea === 2) ? 'transparent' : 'black'
    }
    for (let i = 0; i < surplusWind.length; i++) {
      surplusWind[i].style.backgroundColor = (data.surplusArea === 3) ? 'transparent' : 'black'
    }
    // Identifiers
    document.getElementById("topEnergy1").style.backgroundColor = data.top1;
    document.getElementById("topEnergy2").style.backgroundColor = data.top2;
    document.getElementById("bottomLeftEnergy1").style.backgroundColor = data.bottomLeft1;
    document.getElementById("bottomLeftEnergy2").style.backgroundColor = data.bottomLeft2;
    document.getElementById("bottomRightEnergy1").style.backgroundColor = data.bottomRight1;
    document.getElementById("bottomRightEnergy2").style.backgroundColor = data.bottomRight2;

  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <h1 style={{ color: (this.state.countDown) ? 'red' : 'black' }}>{this.state.time.minutes}:{this.state.time.seconds}:{this.state.time.milliseconds}</h1>
        <button className={classes.button} type="button" onClick={(this.state.startReset === "Start Timer") ? this.startTimer : this.resetTimer}>{this.state.startReset}</button>
        <button className={classes.button} type="button" onClick={this.stopTimer}>Stop</button>
        <button className={classes.button} type="button" onClick={async () => this.setRandomize(await randomize())}>Randomize!</button>

        <div style={{ display: "inline-flex", maxHeight: "100%" }}>
          <img src={seniorPlaymat} style={{ width: "100%" }}>
          </img>
          {/* Logic Container */}
          <div style={{ backgroundColor: 'transparent', height: (this.state.windowWidth / 6695) * 3240, width: "100%", position: 'absolute' }}>
            {/* Top House 2 Energy */}
            <div style={{ height: "2.6%", backgroundColor: 'transparent', marginTop: "5.2%", marginLeft: "70.3%", marginRight: "25.53%", display: 'flex' }}>
              <div id="topEnergy1" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div id="topEnergy2" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            {/* Surplus Water Energy */}
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "6.3%", marginLeft: "76.2%", marginRight: "17.8%", display: 'flex' }}>
              <div className="surplusWater" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusWater" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "1.9%", marginLeft: "76.2%", marginRight: "17.8%", display: 'flex' }}>
              <div className="surplusWater" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusWater" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            {/* Surplus Solar Energy */}
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "-1%", marginLeft: "17%", marginRight: "77%", display: 'flex' }}>
              <div className="surplusSolar" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusSolar" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "1.5%", marginLeft: "17%", marginRight: "77%", display: 'flex' }}>
              <div className="surplusSolar" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusSolar" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            {/* Surplus Wind Energy */}
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "-2.3%", marginLeft: "49.25%", marginRight: "44.75%", display: 'flex' }}>
              <div className="surplusWind" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusWind" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            <div style={{ height: "4.76%", backgroundColor: 'transparent', marginTop: "1.5%", marginLeft: "49.25%", marginRight: "44.75%", display: 'flex' }}>
              <div className="surplusWind" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div className="surplusWind" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            {/* Bottom Right House 2 Energy */}
            <div style={{ height: "2.6%", backgroundColor: 'transparent', marginTop: "13.6%", marginLeft: "73.5%", marginRight: "22.53%", display: 'flex' }}>
              <div id="bottomRightEnergy1" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div id="bottomRightEnergy2" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
            {/* Bottom Left House 2 Energy */}
            <div style={{ height: "2.6%", backgroundColor: 'transparent', marginTop: "-1.3%", marginLeft: "4%", marginRight: "91.9%", display: 'flex' }}>
              <div id="bottomLeftEnergy1" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
              <div style={{ height: "100%", backgroundColor: 'transparent', flex: 1 }}></div>
              <div id="bottomLeftEnergy2" style={{ height: "100%", backgroundColor: 'black', flex: 1 }}></div>
            </div>
          </div>
        </div>
        <p>Copyright © 2021 World Robot Olympiad Association Ltd. , TehDrink</p>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
